'use client'

import { useTranslations } from 'next-intl'

import { contentDesignFormConfig } from '@/content-from-sections/client'

import { ContentForm } from '../../ContentForm'
import {
	qrNameFormConfig,
	shareVideoFormConfig,
	TQrContentFormSection,
	videoFormConfig,
	videoInformationFormConfig,
	welcomeScreenFormConfig,
} from '../../contentFormSections'
import { QR_TYPE, TContentFormProps } from '../../generatorTypes'

export const VideoContentForm = (props: TContentFormProps) => {
	const t = useTranslations()

	const config = {
		formSectionList: [
			contentDesignFormConfig(t),
			videoInformationFormConfig(t),
			videoFormConfig(t),
			shareVideoFormConfig(t),
			welcomeScreenFormConfig(t),
			qrNameFormConfig(t),
		] satisfies TQrContentFormSection[],
	}

	return <ContentForm qrType={QR_TYPE.Video} config={config} {...props} />
}
